import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../components/Default.vue'
import store from '../store/index'
import Page404 from '../shared/Page404.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  //--=====================================REPORTES=====================================
  {
    path: '/reportes',
    name: 'reho',
    component: () => import( /* webpackChunkName: "RepHomeView" */ '../modules/reportes/views/RepHomeView.vue'),
    beforeEnter: authAdminSecretario
  },

 /* Ruta de planificaciones drive */
  {
    path: '/drive',
    name: 'driv',
    component: () => import( /* webpackChunkName: "HomeDrive" */ '../modules/drive/views/HomeDrive.vue'),
    beforeEnter: authDocenteAdminVicerrector
  },
  //--=====================================TUTORIAS=====================================
  {
    path: '/tutoria',
    name: 'tuto',
    component: () => import( /* webpackChunkName: "HomeTutoria" */ '../modules/tutoria/HomeTutoria.vue'),
    beforeEnter: authDocenteAdminVicerrector
  },

  //--=====================================CALIFICACIONES=====================================
  {
    path: '/cursos-asignados',
    name: 'cuas',
    component: () => import( /* webpackChunkName: "CursoAsignadoView" */ '../modules/notas/views/CursoAsignadoView.vue'),
    beforeEnter: authDocenteAdmin
  },
  {
    path: '/cursos-computo',
    name: 'cuco',
    component: () => import( /* webpackChunkName: "ComputoView" */ '../modules/notas/views/ComputoView.vue'),
    beforeEnter: authDocenteAdmin
  },

 /* ADMINISTRADOR DEL SITIO */
 {
  path: '/admin-site',
  name: 'admin',
  component: () => import( /* webpackChunkName: "HomeSetting" */ '../modules/setting/HomeSetting.vue'),
  beforeEnter: authAdmin
},

 /* DESTRESAS */
  {
    path: '/ambitos-destrezas',
    name: 'dest',
    component: () => import( /* webpackChunkName: "DestrezasView" */ '../modules/setting/registros/views/DestrezasView.vue'),
    beforeEnter: authAdmin
  },


  /* HORARIOS */
  {
    path: '/horarios-clases',
    name: 'hocl',
    component: () => import( /* webpackChunkName: "HorarioView" */ '../modules/horarios/views/HorarioView.vue'),
  },
  {
    path: '/hora-conf',
    name: 'hoho',
    component: () => import( /* webpackChunkName: "HoraView" */ '../modules/horarios/views/HoraView.vue'),
  },

  /* MODULO ESTUDIANTES CALIFICACIONES */
  {
    path: '/calificaciones',
    name: 'cali',
    component: () => import( /* webpackChunkName: "EstadisticaView" */ '../modules/alumno/calificaciones/views/CalificaView.vue'),
    beforeEnter: authEstudiante
  },

  /* AULAS VIRTUALES DOCENTES */
  {
    path: '/courses',
    name: 'audo',
    component: () => import( /* webpackChunkName: "CoursesView" */ '../modules/aulasvirtuales/CoursesView.vue'),
    beforeEnter: authDocenteAdmin,
  },
  {
    path: '/home-aulas',
    name: 'auhom',
    component: () => import( /* webpackChunkName: "HomeAulas" */ '../modules/aulasvirtuales/HomeAulas.vue'),
    beforeEnter: authDocenteAdmin,
  },

  /* AULAS VIRTUALES ESTUDIANTES */
  {
    path: '/my-course',
    name: 'myco',
    component: () => import( /* webpackChunkName: "MycouseView" */ '../modules/aulasvirtuales/views/estudiante/MycouseView.vue'),
    beforeEnter: authEstudiante
  },
  {
    path: '/my-course-home',
    name: 'myho',
    component: () => import( /* webpackChunkName: "MyHomeView" */ '../modules/aulasvirtuales/views/estudiante/MyHomeView.vue'),
    beforeEnter: authEstudiante
  },

  {
    path: "/:catchAll(.*)",
    name: "NotFound",
    component: Page404,
    meta: {
      requiresAuth: false
    }
  }
]

function authAdmin(to, from, next) {
  let user = store.getters.user;
  if (user) {
    if (!user.roles.includes('Admin')) {
      return next('/:catchAll(.*)');
    }
  }
  return next();
}

function authDocente(to, from, next) {
  let user = store.getters.user;
  if (user) {
    if (!user.roles.includes('Docente')) {
      return next('/:catchAll(.*)');
    }
  }
  return next();
}
function authEstudiante(to, from, next) {
  let user = store.getters.user;
  if (user) {
    if (!user.roles.includes('Estudiante')) {
      return next('/:catchAll(.*)');
    }
  }
  return next();
}
function authDocenteEstudiante(to, from, next) {
  let user = store.getters.user;
  if (user) {
    if (!user.roles.includes('Estudiante') && !user.roles.includes('Docente')) {
      return next('/:catchAll(.*)');
    }
  }
  return next();
}
function authDocenteAdmin(to, from, next) {
  let user = store.getters.user;
  if (user) {
    if (!user.roles.includes('Docente') && !user.roles.includes('Admin')) {
      return next('/:catchAll(.*)');
    }
  }
  return next();
}
function authDocenteAdminSecretario(to, from, next) {
  let user = store.getters.user;
  if (user) {
    if (!user.roles.includes('Docente') && !user.roles.includes('Admin') && !user.roles.includes('Secretario')) {
      return next('/:catchAll(.*)');
    }
  }
  return next();
}
function authDocenteAdminVicerrector(to, from, next) {
  let user = store.getters.user;
  if (user) {
    if (!user.roles.includes('Docente') && !user.roles.includes('Admin') && !user.roles.includes('Vicerrector')) {
      return next('/:catchAll(.*)');
    }
  }
  return next();
}
function authAdminSecretario(to, from, next) {
  let user = store.getters.user;
  if (user) {
    if (!user.roles.includes('Admin') && !user.roles.includes('Secretario')) {
      return next('/:catchAll(.*)');
    }
  }
  return next();
}
const router = createRouter({
  //mode: 'hash',
  history: createWebHistory(process.env.BASE_URL),
  routes
})
router.onError(error => {
  if (/ChunkLoadError:.*failed./i.test(error.message)) {
    window.location.reload();
  }
  else if (/Loading.*chunk.*failed./i.test(error.message)) {
    window.location.reload();
  }
});
router.onError((error) => {
  const jsPattern = /Loading chunk (\S)+ failed/g
  const cssPattern = /Loading CSS chunk (\S)+ failed/g
  const isChunkLoadFailed = error.message.match(jsPattern || cssPattern)
  if (isChunkLoadFailed) {
    window.location.reload()
  }
})

// router.onError(error => {
//   console.error(error);
//   Vue.prototype.$log.error('Failure Reason: ', error.message, error);
//   if (/ChunkLoadError:.*failed./i.test(error.message)) {
//     Vue.prototype.$log.error('Reloading Window 1');
//     window.location.reload();
//   }
//   else if (/Loading.*chunk.*failed./i.test(error.message)) {
//     Vue.prototype.$log.error('Reloading Window 2');
//     window.location.reload();
//   }
// });

export default router